import { render, staticRenderFns } from "./toggle-btn.vue?vue&type=template&id=72840aae&scoped=true&"
import script from "./toggle-btn.vue?vue&type=script&lang=js&"
export * from "./toggle-btn.vue?vue&type=script&lang=js&"
import style0 from "./toggle-btn.vue?vue&type=style&index=0&id=72840aae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72840aae",
  null
  
)

export default component.exports